export const HERO_CAT_CHIP_ORDER = [7, 1, 41, 40, 8, 4, 2, 3];
export const SCROLL_ID = 'servicespage_services';

export const META_TITLE = 'HelloTech Services';
export const META_DESCRIPTION =
  'HelloTech offers unparalleled tech services to enhance your digital lifestyle. From seamless installations to troubleshooting, our expert technicians ensure your devices run smoothly. Explore our comprehensive range of services tailored to your needs.';
